import { queryOptions } from "@tanstack/react-query";
import { restGet } from "./supabaseRest";

export interface VideoPage {
  id: string;
  slug: string;
  youtube_id: string;
  title: string;
  meta_description: string | null;
  summary: string | null;
  html_content: string;
  category: string | null;
  upload_date: string | null;
}

const COLS = "id,slug,youtube_id,title,meta_description,summary,html_content,category,upload_date";

export const videoThumb = (id: string) => `https://i.ytimg.com/vi/${id}/hqdefault.jpg`;
export const videoEmbed = (id: string) => `https://www.youtube-nocookie.com/embed/${id}`;

export const videoPagesListQuery = queryOptions({
  queryKey: ["video-pages"],
  queryFn: async () => {
    const rows = await restGet<VideoPage[]>(`video_pages?select=${COLS}&is_published=eq.true&order=sort_order.asc,created_at.desc`);
    if (!rows) throw new Error("Videos could not be loaded. Please try again.");
    return rows;
  },
  staleTime: 60_000,
});

export function videoPageQuery(slug: string) {
  return queryOptions({
    queryKey: ["video-page", slug],
    queryFn: async () => {
      const rows = await restGet<VideoPage[]>(`video_pages?select=${COLS}&slug=eq.${encodeURIComponent(slug)}&is_published=eq.true&limit=1`);
      if (!rows) throw new Error("This video could not be loaded. Please try again.");
      return rows[0] ?? null;
    },
    staleTime: 60_000,
  });
}

export function videoSchema(v: VideoPage, url: string) {
  return {
    "@context": "https://schema.org",
    "@type": "VideoObject",
    name: v.title,
    description: v.meta_description || v.summary || v.title,
    thumbnailUrl: videoThumb(v.youtube_id),
    ...(v.upload_date ? { uploadDate: `${v.upload_date}T12:00:00-05:00` } : {}),
    contentUrl: `https://www.youtube.com/watch?v=${v.youtube_id}`,
    embedUrl: `https://www.youtube.com/embed/${v.youtube_id}`,
    url,
    publisher: { "@type": "Organization", name: "Rex & Sons RVs", url: "https://www.rexandsonsrvs.com" },
  };
}
